import React, { useEffect, useState } from "react";
import {
  Modal,
  Input,
  Form,
  Row,
  Col,
  Radio,
  Button,
  Typography,
  Switch,
  Upload,
  message,
  Select,
  Collapse,
  Icon
} from "antd";
const {Panel} = Collapse;
import { CloudUploadOutlined } from "@ant-design/icons";

import TextArea from "antd/lib/input/TextArea";
import { platformApi } from "../../../../api";
import { ContextAPI } from "../../../../ContextAPI";
import { useContext } from "react";

const { Item } = Form;
const { Text } = Typography;

const AutoCallerModal = ({ open, close, getTemplates, isModify, selectedData }) => {
  const { loginCredintials } = useContext(ContextAPI);

  
  const [mode, setMode] = useState("text");
  const [textValue, setTextValue] = useState("");
  const [audioUrl, setAudioUrl] = useState("");
  const [file, setFile] = useState(null);
  const [templateName, setTemplateName] = useState("");
  const [toggle, setToggle] = useState(true);
  const [loading, setLoading] = useState(false);
  const [submodule, setSubmodule] = useState("");
  // const [modify, setModify] = useState(isModify);
  const [legends,setLegends] = useState([]);

  const submodules = ["Service Reminder", "Insurance Renewal Reminder"];

  useEffect(() => {
    if (selectedData) {
      setTemplateName(selectedData[0].name || "");
      setSubmodule(selectedData[0].submodule || "");
      setToggle(selectedData[0].status === "active");
      setAudioUrl(selectedData[0].audioUrl || "");
      setLegends(selectedData[0].legends?JSON.parse(selectedData[0].legends):[]);

      // Determine mode based on presence of text
      if (selectedData[0].text!=null) {
        setMode("text");
        setTextValue(selectedData[0]?.text);
      } else {
        setMode("upload");
      }
    } else {
      resetForm();
    }
  }, [selectedData]);

  const resetForm = () => {
    setTemplateName("");
    setSubmodule("");
    setMode("text");
    setTextValue("");
    setAudioUrl("");
    setFile(null);
    setToggle(false);
    setLegends([]);
    // setModify(isModify);
  };

  const handleClose = () => {
    close();
    resetForm();
  };

  // const handleGenerateAudio = () => {
  //   if (!textValue) return message.warning("Please enter text");

  //   setLoading(true);
  //   const data = {
  //     text: textValue,
  //   };

  //   platformApi
  //     .post("/api/autocall/generate-audio", data)
  //     .then((res) => {
  //       if (res.data.audioUrl) {
  //         setAudioUrl(res.data.audioUrl);
  //         message.success("Audio generated successfully");
  //       } else {
  //         message.error("Failed to generate audio");
  //       }
  //     })
  //     .catch((err) => {
  //       console.error("Error:", err.message);
  //       message.error("Error generating audio");
  //     })
  //     .finally(() => setLoading(false));
  // };

  const handleFileChange = (info) => {
    const selectedFile = info.fileList[0]?.originFileObj;
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  const handleSave = async () => {
    const formData = new FormData();
    formData.append("name", templateName);
    formData.append("module", "AutoCaller");
    formData.append("submodule", submodule);
    formData.append("status", toggle ? "active" : "not active");

    if (mode === "text") {
      formData.append("text", textValue);
      
      if (audioUrl && !audioUrl.includes(selectedData?.[0]?.audioUrl)) {
        try {
          const response = await fetch(audioUrl);
          const blob = await response.blob();
          const file = new File([blob], "audio.m4a", { type: blob.type });
          formData.append("file", file);
        } catch (error) {
          console.error("Error fetching the audio file:", error);
          message.error("Failed to fetch audio file.");
          return;
        }
      }
    } else if (file) {
      formData.append("file", file);
    }

    if (selectedData && isModify) {
      formData.append("legends",selectedData[0].legends);
      platformApi
        .put(`/api/autocall/${selectedData?.[0].id}`, formData)
        .then((res) => {
          message.success("Template updated successfully!");
          handleClose();
          getTemplates();
        })
        .catch(() => {
          message.error("Failed to update template.");
        });
    } else {
      // Create new template
      platformApi
        .post("/api/autocall", formData)
        .then((res) => {
          message.success("Template saved successfully!");
          handleClose();
          getTemplates();
        })
        .catch(() => {
          message.error("Failed to save template.");
        });
    }
  };

  const isReadOnly = selectedData && !isModify;
  

  return (
    <Modal
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            maxHeight: "65vh",
            overflowY: "auto"
          }}
        >
          <span style={{ fontSize: 16, fontWeight: 500 }}>
            Auto Caller Template
          </span>
          {loginCredintials.department.role === "CEO" && (
            <span style={{ marginRight: "20px" }}>
              <Switch
                checked={toggle}
                onChange={(checked) => setToggle(checked)}
                disabled={isReadOnly}
              />
            </span>
          )}
        </div>
      }
      visible={open}
      onCancel={handleClose}
      wrapClassName="department-modal"
      width="40vw"
      footer={[
        <Button key="cancel" onClick={close}>
          Cancel
        </Button>,
        !isReadOnly && (
          <Button key="save" type="primary" onClick={handleSave}>
            {selectedData && !isModify ? "Update" : "Save"}
          </Button>
        ),
      ]}
    >
      <Form layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Item label="Module Name">
              <Input placeholder="Module" value="AutoCaller" disabled={true} />
            </Item>
          </Col>
          <Col span={12}>
            <Item label="Submodule">
              <Select
                placeholder="Select Submodule"
                value={submodule}
                onChange={(value) => setSubmodule(value)}
                disabled={isReadOnly}
              >
                {submodules.map((submodule) => (
                  <Select.Option key={submodule} value={submodule}>
                    {submodule}
                  </Select.Option>
                ))}
              </Select>
            </Item>
          </Col>
        </Row>

        <Item label="Template Name">
          <Input
            placeholder="Enter Template Name"
            value={templateName}
            onChange={(e) => setTemplateName(e.target.value)}
            disabled={isReadOnly}
          />
        </Item>

        {!isReadOnly && (
          <Item label="Choose Mode">
            <Radio.Group
              value={mode}
              onChange={(e) => {
                setMode(e.target.value);
                setAudioUrl("");
                setFile(null);
              }}
              disabled={isReadOnly}
            >
              <Radio value="text">Input Text to Audio</Radio>
              <Radio value="upload">Import Audio File</Radio>
            </Radio.Group>
          </Item>
        )}

        {mode === "text" ? (
          <>
            <Item label="Text to Voice">
              <TextArea
                value={textValue}
                onChange={(e) => setTextValue(e.target.value)}
                autoSize={{ minRows: 4 }}
                placeholder="Enter your message text"
                disabled={isReadOnly}
              />
              {/* {!isReadOnly && (
                <div style={{ textAlign: "right", marginTop: 8 }}>
                  <Button
                    loading={loading}
                    type="primary"
                    // onClick={handleGenerateAudio}
                    disabled={!textValue}
                  >
                    Generate Audio
                  </Button>
                </div>
              )} */}
            </Item>
            {(audioUrl) && (
              <Item label={isReadOnly ? "Audio" : "Generated Audio"}>
                <audio 
                  controls 
                  src={audioUrl} 
                  style={{ width: "100%" }} 
                />
              </Item>
            )}
          </>
        ) : (
          <>
            <Item label="Upload Audio File">
              <Upload
                beforeUpload={() => false}
                onChange={handleFileChange}
                maxCount={1}
                accept="audio/*"
                showUploadList={{ showRemoveIcon: !isReadOnly }}
                disabled={isReadOnly}
              >
                <Button 
                  icon={<CloudUploadOutlined />} 
                  disabled={isReadOnly}
                >
                  Upload Audio
                </Button>
              </Upload>
            </Item>
            {selectedData?.[0].audioUrl && (
              <Item label="Current Audio">
                <audio 
                  controls 
                  src={selectedData?.[0].audioUrl} 
                  style={{ width: "100%" }} 
                />
              </Item>
            )}
          </>
        )}
        {mode==="text" &&
        <Item>
          <Collapse
            destroyInactivePanel={true}
            bordered={false}
            expandIcon={({ isActive }) => (
              <Icon type="caret-right" rotate={isActive ? 90 : 0} />
            )}
          >
            <Panel
              style={{
                borderBottom: "none",
              }}
              header={<Text strong>Legends</Text>}
            >
              {legends.map((text, index) => (
                <div key={index}> {text} </div>
              ))}
            </Panel>
          </Collapse>
        </Item>
        }
      </Form>
    </Modal>
  );
};

export default AutoCallerModal;